export const PERSONAL_DETAILS_HEADING = "personal-details-heading";
export const ACCOUNT_SETTING_LABEL = "account-settings-label";
export const PERSONAL_DETAILS_TEXT = "personal-details-text";
export const SAVE_CHANGES_BUTTON = "save-changes";
export const PHONE_LABEL = "phone-label";
export const EMAIL_LABEL = "email-label";
export const PHONE_VALUE = "phone-value";
export const EMAIL_VALUE = "email-value";
export const NAME_FIRST_NAME = "firstName";
export const NAME_LAST_NAME = "lastName";
export const NAME_MIDDLE_NAME = "middleName";
export const PERSONAL_DETAILS_TOAST = "personal-details-toast";
export const CREATED = "CREATED";

export const APPLICATION_STATUS_START_INTAKE = "START_INTAKE";
export const APPLICATION_STATUS_CONTINUE_INTAKE = "CONTINUE_INTAKE";
export const APPLICATION_STATUS_RAC = "START_RAC";
export const APPLICATION_STATUS_CONTINUE_RAC = "CONTINUE_RAC";
export const APPLICATION_STATUS_REAPPLY = "START_REAPPLY";
export const APPLICATION_STATUS_CONTINUE_REAPPLY = "CONTINUE_REAPPLY";
export const APPLICATION_STATUS_RECERTIFY = "START_RECERTIFY";
export const APPLICATION_STATUS_CONTINUE_RECERTIFY = "CONTINUE_RECERTIFY";
export const APPLICATION_STATUS_DISCONTINUE = "DISCONTINUE";
export const APPLICATION_STATUS = "applicationStatus";
export const START_APPLICATION = "start-application";
export const CONTINUE_APPLICATION = "continue-application";
export const RAC_APPLICATION = "rac-application";
export const CONTINUE_RAC_APPLICATION = "continue-rac-application";
export const RECERTIFY_APPLICATION = "recertify-application";
export const REAPPLY_APPLICATION = "reapply-application";
